import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, SproutIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} tomos premium`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonos estratégicos`
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="tech-grid-light relative isolate overflow-hidden bg-white" data-id="element-109" data-mp="sai4p4p7cx7b">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-110" data-mp="ncgjad4b0lso" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-111" data-mp="neauv0tor1k3">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-leaf-200 bg-leaf-50 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-leaf-700" data-id="element-112" data-mp="3d2tpjcx5eqg4">
          <SproutIcon className="h-4 w-4" aria-hidden="true" data-id="element-113" data-mp="39authk0ozz0e" /> Megapack Gestión Ambiental Listo
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-navy-900 sm:text-5xl lg:text-6xl" data-id="element-114" data-mp="3e8ehhbn6zq5j">
          Todo tu año de Gestión Ambiental
          <br data-id="element-115" data-mp="2viokchvyisag" />
          <span className="text-leaf-600" data-id="element-116" data-mp="2vi54r7ts4fzl">resuelto en una tarde.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-117" data-mp="2hinbog9gagkf">
          <img src={productImage} alt="Megapack Gestión Ambiental Listo: nueve tomos y cinco bonos sobre fundamentos, recursos naturales, impactos, agua y suelo, residuos, biodiversidad, cambio climático y sistemas de gestión" className="mx-auto w-full rounded-xl" data-id="element-118" data-mp="s3cmudv0pps5" />
        </motion.div>

        <div className="mt-9" data-id="element-119" data-mp="1b0njdqp9m53w">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-120" data-mp="1azuk1asmyhvs">
            Quiero mi Megapack ahora
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-navy-900" data-id="element-121" data-mp="15zzvvf08w6ef">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-navy-100 bg-canvas px-3 py-2" data-id="element-122" data-mp="x0cqyj8b4igm">
              <Icon className="h-3.5 w-3.5 text-leaf-600" aria-hidden="true" data-id="element-123" data-mp="3hqu2kaecg816" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}